import { render, staticRenderFns } from "./MisVideos.vue?vue&type=template&id=a96f4908&scoped=true&"
import script from "./MisVideos.vue?vue&type=script&lang=js&"
export * from "./MisVideos.vue?vue&type=script&lang=js&"
import style0 from "./MisVideos.vue?vue&type=style&index=0&id=a96f4908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96f4908",
  null
  
)

export default component.exports